module.exports = __webpack_public_path__ + "static/media/ios-tablet-portrait.f3c81025.svg";